import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit'
import User from '../../models/User'
import { fetchUserCode } from '../utils/users'

import { IPublicBeneficiaryResponse } from '../../clients/medicareApiClient'
import { RootState } from 'redux/config'

// TODO - Deprecate fetchUser in place of fetchUserWithMessages
// TODO - Completely deprecate the enableMessageCenter Feature Flag
export const fetchUser = createAsyncThunk(
  'users/fetchUser',
  async (_: undefined, { dispatch }) => {
    await fetchUserCode(dispatch)
  }
)

interface IUserReducer {
  user?: User
  reqToken?: string
  status: 'finished' | 'error' | 'loading' | 'idle'
}

type ISetUserAction = IPublicBeneficiaryResponse
type ISetReqTokenAction = {
  reqToken?: string
}

const initialState: IUserReducer = {
  user: undefined,
  reqToken: '',
  status: 'idle'
}

export const userSlice = createSlice({
  name: 'users',
  initialState,
  reducers: {
    setUser: (state: IUserReducer, action: PayloadAction<ISetUserAction>) => {
      state.user = action.payload
    },
    setReqToken: (state: IUserReducer, action: PayloadAction<ISetReqTokenAction>) => {
      state.reqToken = action.payload.reqToken
    },
    clearUser: (state: IUserReducer) => {
      state.user = initialState.user
      state.reqToken = initialState.reqToken
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchUser.pending, (state) => {
        state.status = 'loading'
      })
      .addCase(fetchUser.fulfilled, (state) => {
        state.status = 'finished'
      })
      .addCase(fetchUser.rejected, (state) => {
        state.user = undefined
        state.status = 'error'
      })
  }
})

export const {
  setUser,
  setReqToken,
  clearUser
} = userSlice.actions

// GETTERS
export const getUser = (state: RootState) => state.users.user
export const getUserLoggedInState = (state: RootState) => Boolean(state.users.user)
export const getUserReqToken = (state: RootState) => state.users.reqToken
export const getUserStatus = (state: RootState) => state.users.status

export default userSlice.reducer
